import React, { useEffect, useState } from 'react';
import { UserCircleIcon } from '@heroicons/react/24/outline';

/**
 * Avatar for the signed-in user: initials on a tinted circle, falling back to
 * the profile photo when profile_image_url is set. The main app's ProfileAvatar
 * resolves an uploaded image via utils/profileImageUrl.js, but 19.2 ships
 * ProfilePage without the upload UI, so this demo shows initials by default
 * (kickoff prompt: "ProfileAvatar with initials linking to /profile").
 */
export default function ProfileAvatar({ user, className = 'w-8 h-8' }) {
  const [broken, setBroken] = useState(false);
  const profileImageUrl = user?.profile_image_url;

  useEffect(() => {
    setBroken(false);
  }, [profileImageUrl]);

  if (profileImageUrl && !broken) {
    return (
      <img
        src={profileImageUrl}
        alt={user?.first_name ? `${user.first_name}'s profile` : 'Profile'}
        className={`${className} rounded-full object-cover`}
        onError={() => setBroken(true)}
      />
    );
  }

  const initials = [user?.first_name, user?.last_name]
    .filter(Boolean)
    .map((part) => part[0].toUpperCase())
    .join('');

  if (!initials) {
    return <UserCircleIcon className={className} />;
  }

  return (
    <div
      className={`${className} rounded-full bg-primary-100 text-primary-700 flex items-center justify-center text-xs font-semibold leading-none select-none`}
      aria-hidden="true"
    >
      {initials}
    </div>
  );
}
